import { IS_PRODUCTION, IS_LOCAL_API } from "../utils/env";

export const CURRENT_EVENT_SLUG = "hackthenorth2026";

export const EVENT_ID = IS_LOCAL_API
  ? Number(process.env.REACT_APP_EVENT_ID || 3)
  : IS_PRODUCTION
  ? 1930
  : 1939;

export const APPLICATIONS_SLUG = "hackthenorth2026-applications";

// deprecated for 2026
export const MENTORSHIP_REQUESTS_SLUG = "hackthenorth2025-mentorship-requests";

export const MENTORSHIP_PROFILES_SLUG = "hackthenorth2025-mentorship-profiles";
